import smoothscroll from 'smoothscroll-polyfill';
smoothscroll.polyfill()

export default function(element, offset = 100) {
  window.scrollTo({ top: element.offsetTop - offset, left: 0, behavior: 'smooth' })
}
